<template>
    <div class="horizontal-checkboxes">
        <v-checkbox v-for="(option, key) in options"
            :key="`checkbox${key}`"
            :label = option
            :value = Number(key)
            v-model = selected
            :hide-details="true"
            @change="$emit('change', selected)"
        >　</v-checkbox>
    </div>
</template>
<script>
export default {
    name: 'HorizontalCheckBoxes',

    props: {
        options: {
            required: true,
            type: Object
        },
        value: {
            required: true,
            type: [Array, Number]
        }
    },
    data() {
        return {
            selected: this.value
        }
    },
    watch: {
      value (val) {
        this.selected = Array.isArray(val) ? val : [val]
      }
    }
}
</script>
<style lang="scss" scoped>
.horizontal-checkboxes {
    margin-left: -4px;
}
.v-input.v-input--selection-controls {
    margin-top: 0; 
    padding-top: 0;
    display: inline-block;
    float: left;
    padding-right: 20px;
}
</style>